import script from "./ExchangeChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeChat.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeChat.vue?vue&type=style&index=0&id=1fe8b447&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe8b447"]])

export default __exports__